import { filter } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { BaseComponent } from '../../../../shared/Components/base/base.component';

import { FileUploaderComponent } from '../../../../shared/Components/file-uploader/file-uploader.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PartnerDetailsComponent } from '../partner-details/partner-details.component';

import * as momentHijri from 'moment-hijri';
import { PartnerService } from '../../services/partner-service';
import { AddPartnerComponent } from '../add-partner/add-partner.component';
import { PagingService } from '../../../../shared/Services/PagingService';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'app-get-partner',
  templateUrl: './get-partner.component.html',
  styleUrls: ['./get-partner.component.scss'],
})
export class GetPartnerComponent extends BaseComponent implements OnInit {
  dateTo: string;
  dateFrom: string;
  form: FormGroup;
  constructor(
    public service: PartnerService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private paging: PagingService
  ) {
    super(route, service, paging, '', diag);
  }

  ngOnInit() {
    this.intitForm();
    this.loadEntities();
  }

  intitForm() {
    this.form = this.fb.group({
      nameAR: [''],
    });
  }

  handleSearch() {
    if (!this.form.value.nameAR && !this.dateFrom && !this.dateTo) {
      this.toast.danger('برجاءاختيار الاسم او التاريخ لاتمام عمليةالبحث', 'رساله تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (this.form.value.nameAR) {
      serchTermArr.push(`nameAR:${this.form.value.nameAR.trim()}`);
    }

    if (this.dateFrom) {
      let dateInput = document.getElementById('dateFrom') as HTMLInputElement;
      let modifiedDate = new Date(dateInput.value);
      let dateFrom = new Date(modifiedDate.toString().split('GMT')[0].concat('GMT+0000')).toISOString().split('T')[0];
      serchTermArr.push(`createdDate:>${dateFrom}`);
    }
    if (this.dateTo) {
      let dateInput = document.getElementById('dateTo') as HTMLInputElement;
      let modifiedDate = new Date(dateInput.value);
      let dateTo = new Date(modifiedDate.toString().split('GMT')[0].concat('GMT+0000')).toISOString().split('T')[0];
      serchTermArr.push(`createdDate:<${dateTo}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
  clearFilter() {
    this.dateFrom = '';
    this.dateTo = '';
    this.form.controls['nameAR'].setValue('');
    this.loadEntitiesWithFilter('');
  }

  addNewBlog() {
    this.dialog
      .open(AddPartnerComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }

  detail(model) {
    this.diag.open(PartnerDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddPartnerComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
